import React, { useState, useEffect, useRef } from 'react';
import _ from "lodash";
import Header from './Header';
import Sidebar from './Sidebar';
import CandidateTab from './CandidateTab';
import NotificationPanels from './NotificationPanels';
import '../assets/css/candidate-tab-form.css';
import '../assets/css/inner-tabs.css';
import Loader from './Common/loader';
import { useDispatch, useSelector } from "react-redux";
import { getEducation, updateCampusHireEducation, addEducation } from '../Actions/educationActions';
import { retryApi } from '../Actions/DigiLockerActions.js';
import { getData } from "../Actions/landingAction";

import MainForm from './EducationForm/MainForm';
import QuestionForm from './EducationForm/QuestionForm';
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import { useNavigate, useHistory } from "react-router-dom";
import {
  useParams,
} from "react-router-dom";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import MainFormDigiLocker from './EducationForm/MainFormDigiLocker';
import MainFormDigiLockerNew from './EducationForm/MainFormDigiLockerNew.js';
import ConfirmationPopup from './EducationForm/confirmationPopup.js';
import MainFormNewEducation from './EducationForm/MainFormNewEducation.js';
import ProgressHeading from './Common/ProgressHeading.jsx';

const CandidateEducation = () => {
  const navigate = useNavigate();
  let { activeTab, reference } = useParams();
  let url = window.location.pathname.split('/')
  const dispatch = useDispatch();
  const [education, setEducation] = useState([]);
  const [campusHire, setCampusHire] = useState();
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showDigiRemovePopup, setShowDigiRemovePopup] = useState(false);
  const [showRetryPopup, setShowRetryPopup] = useState(false);
  const [unsavedEmpData, setUnsavedEmpData] = useState({});
  const [role,setRole]=useState();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);


  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  //loading form fields information with get education api
  useEffect(() => {
    const fetchData = async () => {
      dispatch(getEducation());
    };

    fetchData();
    return(() => {
      localStorage.setItem("disableEditDigi", false);
    })
  }, []);

  const [isLoading, setIsLoading] = useState(false);

  //fetching get field data from store
  const storeData = useSelector((state) => state.education);
  const { educationData, loading } = storeData;
  useEffect(() => {
    if (typeof loading !== "undefined" && loading !== null) {
      if (loading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }
    }
  }, [educationData]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    if (
      typeof educationData.data !== "undefined" &&
      educationData.data !== null
    ) {

      ///console.log();
      // if (Object.keys(unsavedEmpData).length == 0) {
      //   setEducation(educationData.data.data);
      // } else {
      //   // debugger;
      //   const updatedData = educationData.data.data;
      //   let newData = _.cloneDeep(unsavedEmpData);
      //   console.log("unsaved", updatedData, newData);
      //   let checksDetailsMain = _.cloneDeep(newData.checksDetails);
      //   let updatedChecksDetails = _.cloneDeep(updatedData.checksDetails);
      //   for (var i in checksDetailsMain) {
      //     checksDetailsMain[i]["uploaded_documents"] = updatedChecksDetails[i]
      //       .uploaded_documents
      //       ? updatedChecksDetails[i].uploaded_documents
      //       : [];
      //     checksDetailsMain[i]["uploaded_instant_documents"] =
      //       updatedChecksDetails[i].uploaded_instant_documents
      //         ? updatedChecksDetails[i].uploaded_instant_documents
      //         : [];
      //   }
      //   newData.checksDetails = _.cloneDeep(checksDetailsMain);
      //   setEducation(newData);
      //   // console.log("unsaved..", unsavedEmpData, employmentData.data.data);
      // }



      if (Object.keys(unsavedEmpData).length == 0) {
        setEducation(educationData.data.data);
      } else {
        const updatedData = educationData.data.data;
        let newData = _.cloneDeep(unsavedEmpData);
        let checksDetailsMain = _.cloneDeep(newData.checksDetails);
        let updatedChecksDetails = _.cloneDeep(updatedData.checksDetails);
        const checksDetailsMainLength = Object.values(checksDetailsMain).length;
        const updatedChecksDetailsLength = Object.values(updatedChecksDetails).length;
        if (checksDetailsMainLength == updatedChecksDetailsLength) {
          for (var i in checksDetailsMain) {
            if (typeof checksDetailsMain !== 'undefined'){
            console.log("cv",checksDetailsMain)
            checksDetailsMain[i]["uploaded_documents"] = updatedChecksDetails[i]
              .uploaded_documents
              ? updatedChecksDetails[i].uploaded_documents
              : [];
            // checksDetailsMain[i]["uploaded_instant_documents"] =
            //   updatedChecksDetails[i].uploaded_instant_documents
            //     ? updatedChecksDetails[i].uploaded_instant_documents
            //     : [];
           }
          }
        } else if (updatedChecksDetailsLength > checksDetailsMainLength) {
          checksDetailsMain.push(
            updatedChecksDetails[updatedChecksDetailsLength - 1]
          );
        } else {
          let checkToBeRemovedIndex = null;
          for (let i = 0; i < checksDetailsMain.length; i++) {
            let isCheckPresent = false;
            for (let j = 0; j < updatedChecksDetails.length; j++) {
              if (
                checksDetailsMain[i].case_check_id ==
                updatedChecksDetails[j].case_check_id
              ) {
                isCheckPresent = true;
                break;
              }
            }
            if (!isCheckPresent) {
              checkToBeRemovedIndex = i;
            }
          }
          if (checkToBeRemovedIndex) {
            let newChecksDetails = [];
            for (let i = 0; i < checksDetailsMain.length; i++) {
              if (i != checkToBeRemovedIndex) {
                newChecksDetails.push(checksDetailsMain[i]);
              }
            }
            checksDetailsMain = _.cloneDeep(newChecksDetails);
          }
        }

        newData.checksDetails = _.cloneDeep(checksDetailsMain);
       
        setEducation(newData);
      }



      setCampusHire(educationData.data.data.show_campus_hire_question);
    }
  }, [educationData, storeData]);

  //question select handler
  const campsuHireStausHandler = (record) => {

    //alert(JSON.stringify(record));

    dispatch(updateCampusHireEducation(record.campusHire));

    // reSetData();
    // reRenderAgain2();
    // setCampusHire(0);

  }



  const educationUpdateCampusHireStoreData = useSelector((state) => state.educationUpdateCampusHire);
  const { educationUpdateCampusHireData, loading: chsLoad, error: chsError } = educationUpdateCampusHireStoreData;



  //after add handler modify existing main state
  useEffect(() => {
    if (
      typeof educationUpdateCampusHireData.status !== "undefined" &&
      educationUpdateCampusHireData.status !== null && educationUpdateCampusHireData.status == 'success'
    ) {
      reSetData();
      reRenderAgain2();
      setCampusHire(0);


    }

  }, [educationUpdateCampusHireData]);




  //question select handler
  const reRenderAgain = (value) => {
    setUnsavedEmpData(value);
    dispatch(getEducation());
  }

  const reRenderAgain2 = () => {
    // setUnsavedEmpData(value);
    dispatch(getEducation());
  }

  const reSetData = (value) => {
    // setUnsavedEmpData(value);
    setUnsavedEmpData({});
  }




  const [newRecord, setNewRecord] = useState({});

  // add education click handler
  // const handleEducationAddClick = (e) => {
  //   e.preventDefault();

  //   dispatch(addEducation());
  //   // reRenderAgain2();

  // };



  const handleEducationAddClick = (e) => {
    e.preventDefault();
    handleAddPopup();
  };

  const handleEditAndRetry = () => {
    setShowRetryPopup(true);
  }

  const callbackRetry = (data) =>{
    console.log(data);
    localStorage.setItem("digiResponse", 0);
    localStorage.setItem("disableEditDigi", false);
    navigate(`/case-initiation/check-detail/${reference}/3`)
    window.location.reload();
  }

  const handleRetryContinue = () => {
    dispatch(retryApi(callbackRetry));
    setShowRetryPopup(false)
  }

  const handleAddPopup = () => {
    setShowAddPopup(true);
  };

  const closeAddPopup = () => {
    setShowAddPopup(false);
  };

 

  const handleEducationRemoveClick = (e) => {
    e.preventDefault();
    setShowDigiRemovePopup(true);
  }


  const addEducationStoreData = useSelector((state) => state.educationAdd);
  const { educationAddData, loading: addLoad, error: addError } = addEducationStoreData;
  const [educationAddedState, setEducationAddedState] = useState();
  const showDigi = localStorage?.getItem('digiResponse');

  //after add handler modify existing main state
  useEffect(() => {
    if (
      typeof educationAddData.data !== "undefined" &&
      educationAddData.data !== null
    ) {
      // const newEducation = { ...education };
      // newEducation['checksDetails'][educationAddData.data.checksCount - 1] = educationAddData.data.checksDetails[0];
      // setEducation(newEducation);
      // setEducationAddedState(1);
      // reRenderAgain();

      dispatch(getData());
      reSetData();
      //  reRenderAgain();
      if(!education.is_digilocker_enabled){
        navigate(
          `/case-initiation/check-detail/${reference}/3/${educationAddData.data.checksDetails[0].case_check_id}`
        );
      }
      reRenderAgain2();

    }

  }, [educationAddData]);

  //on add handler initiate loader
  useEffect(() => {
    if (typeof addLoad !== "undefined" && addLoad !== null) {
      if (addLoad === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);

        reRenderAgain2();
      }

    }
  }, [educationAddData]);

  //cheking if any status is not completed
  // const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] = useState(0);
  // useEffect(() => {

  //   if (
  //     typeof education.checksDetails !== "undefined" &&
  //     education.checksDetails !== null
  //   ) {
  //     //     alert("f  ");
  //     setCatchIfAnyStatusIsNotCompleted(0);
  //     Object.entries(education.checksDetails).map(([key, value]) => {
  //       if (value.check_status != 2) {
  //         setCatchIfAnyStatusIsNotCompleted(1);
  //       }

  //     });
  //   }
  // }, [education]);


  const [checkStatus, setCheckStatus] = useState(0);
  useEffect(() => {
    if (typeof education.checksDetails !== "undefined" && education.checksDetails !== null) {
      console.log("education checks length...", education)
      Object.entries(education.checksDetails).map(([key, value]) => {
        if (value.check_status != 2) {
          setCheckStatus(1);
        }
      });
    }
  }, [education]);

  return (
    <>
      {isLoading && <Loader />}
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section className="main-section candidate-tab-form" style={{ paddingTop: '60px' }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-2 col-md-2 col-sm-12 w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Education"} />
            </div>
            <div className="col-lg-9 col-md-10 col-sm-12 bg-gray-mbl">
              {/* <br /> */}
              {/*Form*/}
              {/* <form ref={form} className="p-3 form2 form-section" style={{ minHeight: '700px' }}> */}
              <form className="p-3 form2 form-section" style={{ minHeight: '700px' }}>
                <div className="d-flex justify-content-between align-items-center flex-column-mbl flex-start-mbl">
                <div className='d-flex justify-content-between align-items-start row w-100  px-3'>
                    <div className='col-lg-8 col-md-6 col-sm-12'>
                    <StepCount activeTab={"Education"} />
                    <h2 className="fnt-smi-bld">{ clientId == '480158' && 'Highest'} Education</h2>

                    {/* <p className="text-muted">{education?.education_config_msg}</p> */}
                    {/* <p className="text-muted">Add your highest education degree/certificate/all marksheets</p> */}
                    {(campusHire === 0 && education.is_digilocker_enabled) || education?.education_config_msg ? 
                    education?.education_config_msg ? 
                    <p className="text-muted mt-0">{education?.education_config_msg}</p> :
                    <p className="text-muted mt-0">Add your highest education degree/certificate/all marksheets</p>
                    : ''}
                    {/*  */}
                    { clientId == '315466' ?
                      <div
                        class="alert alert-primary has-icon d-flex flex-column"
                        role="alert"
                        style={{padding: 12}}
                      >
                        <div class="d-flex">
                          <span class="" style={{marginLeft: -5}}>Please follow the below instructions while filling the form :-
                          </span>
                        </div>
                        <small class="mt-1 mb-1">
                        <li>
                        Diploma before graduation not to be uploaded. <br />
                        </li>
                        <li>
                        Intermediate(12th)- Not to be uploaded. <br />
                        </li>
                        <li>
                        If only Graduation is completed please upload only Graduation. <br />
                        </li>
                        <li>
                        Post graduation and above please do upload the concern certificate. <br />
                        </li>
                        </small>
                      </div>
                      : ''
                    }  
                    </div>
                    {url[url.length - 1] == 'uploadDigi'?
                   <div className='col-lg-12 col-md-12 col-sm-12 d-flex justify-content-lg-end justify-content-md-end justify-content-sm-start'>
                    <div className="btn btn-outline-secondary" onClick={handleEditAndRetry}>
                      Edit & Retry DigiLocker Fetch
                    </div>
                    
                  </div>
                    :
                    <div>
                      {/* <div className="btn btn-primary" onClick={handleEducationAddClick}>
                        + Add Qualification
                      </div>
                      {
                        !!(typeof education.checksDetails !== "undefined" && education.checksDetails !== null && Object.keys(education.checksDetails).length > 1) && 
                        <div className="btn btn-outline-secondary text-dark ml-2" onClick={handleEducationRemoveClick}>
                        - Remove Qualification
                      </div>
                      } */}
                    </div>}
                  </div>

                  {/* {catchIfAnyStatusIsNotCompleted} */}
                  {/* 
                  {catchIfAnyStatusIsNotCompleted === 0 && */}
                  {/* {(education.is_custom_education == 1 && campusHire === 0 && showDigi!=1) &&
                    <button className="btn btn-primary add-btn" style={{ minWidth: '155' + 'px' }} onClick={(e) => handleEducationAddClick(e)}>+ Add Education</button>
                  } */}
                  {/* {(!education.is_digilocker_enabled && education.is_custom_education == 1 && campusHire === 0 && showDigi!=1) &&
                    <button className="btn btn-primary add-btn" style={{ minWidth: '170' + 'px' }} onClick={(e) => handleEducationAddClick(e)}>+ Add Education</button>
                  } */}
                </div>

                {campusHire === 1 &&
                  <QuestionForm
                    campsuHireStaus={campsuHireStausHandler}
                  />
                }

                {/* new education form */}
                {campusHire === 0 && !education.is_digilocker_enabled && <MainFormNewEducation reSetData={reSetData} edu={education} reRenderAgain={reRenderAgain} reRenderAgain2={reRenderAgain2} active={activeTab} reference={reference} showAddPopup={showAddPopup} setShowAddPopup={setShowAddPopup}
                  closeAddPopup={closeAddPopup}
                  checkStatus={checkStatus} />}

                {/* {campusHire === 0 && !education.is_digilocker_enabled && <MainForm reSetData={reSetData} edu={education} reRenderAgain={reRenderAgain} reRenderAgain2={reRenderAgain2} active={activeTab} reference={reference} showAddPopup={showAddPopup} setShowAddPopup={setShowAddPopup}
                  closeAddPopup={closeAddPopup}
                  checkStatus={checkStatus} />} */}


{/*                 
                {campusHire === 0 && education.is_digilocker_enabled ?<MainFormDigiLocker reSetData={reSetData} edu={education} reRenderAgain={reRenderAgain} reRenderAgain2={reRenderAgain2} active={activeTab} reference={reference} showAddPopup={showAddPopup}
                  closeAddPopup={closeAddPopup}
                  proceedAdd={proceedAdd} checkStatus={checkStatus} initialKey={1}/>:''}   */}

                {campusHire === 0 && education.is_digilocker_enabled ?<MainFormDigiLockerNew campusHire={campusHire} showDigi={showDigi} reSetData={reSetData} edu={education} openreRenderAgain={reRenderAgain} reRenderAgain2={reRenderAgain2} active={activeTab} reference={reference} showDigiRemovePopup={showDigiRemovePopup} setShowDigiRemovePopup={setShowDigiRemovePopup}
                   checkStatus={checkStatus} initialKey={1}/>:''}    
  
                {/* </form> */}
                {/*Form*/}
                {/* <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span>
                  </div>
                </div>
              </div> */}
              </form>
              <Footer />
            </div>
          </div>
        </div>
      </section>
      {showRetryPopup==true&&
        <>
        <div
          className={
            "dashboard custom-modal-dialog " +
            "show"
          }
          onClick={(e) => setShowRetryPopup(false)}
        >
          <div
            className="modal-wrapper"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div
              className="modal-content p-4 no-scroll"
              style={{ maxWidth: "370px" }}
            >
              <div className="text-left">
                {/* <img src={ExclamationIcon} alt="" /> */}
                <h5 className="mt-3">Warning</h5>
                <p className="text-muted">All fetched documents will be lost. Do you want to edit details and retry fetch?</p>
              </div>
  
              <div className="row">
                <div className="col-md-12 d-flex justify-content-between">
                  <button
                    className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
                    onClick={(e) => setShowRetryPopup(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className={
                      
                    "btn btn-danger btn-lg btn-block mt-3"
                    }
                    onClick={
                       handleRetryContinue
                    }
                      
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      }


      {/* <div className="dashboard custom-modal-dialog Education-modal show" id="empGap">
        <div className="modal-wrapper">
          <div
            className="modal-content p-4 no-scroll"
            style={{ overflow: "unset", maxHeight: "unset" , width:"434px" }}
          >
          <div>
            <h4>Education check via Digilocker</h4>
            <p>You will be redirected to DigiLocker page to fetch education documents please follow simple 5 steps</p>
            <ol class="p-3">
              <li>
                Sign in using your Aadhar number.</li>
                <li>Verify your identity with OTP.</li>
                <li>Access your Digilocker documents securely.</li>
                <li>Provide Consent for Document attachment.</li>
                <li>Redirect back to iBridge Application.</li>
            </ol>
            <h6 class="fnt-16 text-primary">Not found your education document on Digilocker?</h6>
            <p class="fnt-12 text-gray text-justify">* If your university or board is not currently listed on DigiLocker, don't worry! You can easily proceed by manually uploading the required documents in the next step.</p>
          </div> 

          
            <div class="row">
              <div class="col-12">
                <button
                  className="btn btn-primary btn-lg btn-block">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
export default CandidateEducation;